import type { POSSourceParser, POSImportData, OutletLocationMapping } from './types';

export const EpayParser: POSSourceParser = {
  id: 'epay',
  name: 'Epay',
  description: 'Import products from an Epay POS export',
  acceptedFileTypes: ['.csv', '.xlsx'],
  isAvailable: false,

  async detectOutlets(_file: File): Promise<string[]> {
    throw new Error('Epay import is not yet available');
  },

  async parse(
    _file: File,
    _outletMapping?: OutletLocationMapping
  ): Promise<POSImportData> {
    throw new Error('Epay import is not yet available');
  },
};
